<template>
    <div v-if="loaded" :key="appKey" class="h-full">
        <TopMenu/>
        <RouterView />
        <Impersonate v-if="user && user.is_impersonating"/>
    </div>
</template>

<script setup>
import { RouterView, useRoute, useRouter } from 'vue-router'
import { onMounted, ref } from "vue";
import { getQueryParam } from "@/libs/helper.js";
import emitter from "@/libs/emitter.js";
import Storage from '@/libs/storage.js';
import { useUserStore } from "@/store/user.js";
import { storeToRefs } from "pinia";
import TopMenu from "@/components/TopMenu.vue";
import Impersonate from "@/components/Impersonate.vue";

const router = useRouter();
const route = useRoute();
const userStore = useUserStore();
const loaded = ref(false);
const appKey = ref(1);
const { user } = storeToRefs(userStore);

emitter.on('languageChanged', () => {
    appKey.value++
});

emitter.on('userLoggedOut', () => {
    router.push({
        name: 'login',
        query: { redirect: route.fullPath }
    });
});

const getAndSetReferralCode = () => {
    const ref = getQueryParam('ref');

    if (ref) {
        const storage = new Storage();
        storage.set('ref', ref);
    }
}

onMounted(async () => {
    await userStore.fetch();

    if (route.meta.auth && ! user.value) {
        await router.push({ name: 'login' })
    }

    loaded.value = true;
    getAndSetReferralCode();
});
</script>
